import React, { useState } from "react";
import {
  Modal,
  Button,
  ListGroup,
  InputGroup,
  FormControl,
  Form,
} from "react-bootstrap";
import { deleteGroupMember } from "../../../api/apiHandler";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
// import { FaPlus } from "react-icons/fa";

const ParticipantsPopup = ({
  show,
  onHide,
  participants,
  selectedChat,
  fetchGroupMembers,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredParticipants = participants?.filter((p) =>
    `${p.first_name} ${p?.email}`
      ?.toLowerCase()
      ?.includes(searchTerm?.toLowerCase())
  );

  const handleDeleteMember = async (val) => {
    try {
      const data = {
        chat_room_id: selectedChat?.id,
        patient_id: val.id,
      };

      let response = await deleteGroupMember(data);
      response = JSON.parse(response);
      console.log(response, "responseresponseresponse");
      if (response?.code === 200) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 1000,
        });
        fetchGroupMembers(selectedChat);
      } else {
        toast.error(response?.message || "Failed to remove member");
      }
    } catch (error) {
      console.error("Error removing member:", error);
      toast.error("An error occurred while removing the member");
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="modal-dialog-scrollable"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {" "}
          {selectedChat.name
            ? selectedChat.name
            : selectedChat?.user?.first_name}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <InputGroup className="mb-3">
          <FormControl
            placeholder="Search by name or email address"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>

        <ListGroup variant="flush">
          {filteredParticipants?.map((participant, index) => (
            <ListGroup.Item
              key={index}
              className="d-flex align-items-center"
              action
            >
              <img
                src={"/assets/images/logo.png"}
                alt={participant?.first_name}
                className="rounded-circle me-3"
                width={40}
                height={40}
              />
              <div className="flex-grow-1">
                <div className="fw-medium">{participant?.first_name}</div>
                <div className="text-muted" style={{ fontSize: "0.875rem" }}>
                  {participant.email}
                </div>
              </div>
              {selectedChat?.is_group === true &&
                localStorage.getItem("user_login_type_role") == 2 && (
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      handleDeleteMember(participant);
                    }}
                    className={`ms-2 mt-1  `}
                    style={{ width: 10, height: 10, display: "inline-block" }}
                  >
                    {delIcon}
                  </span>
                )}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
};

export default ParticipantsPopup;

let delIcon = (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.19667 17.0217 1.00067 16.5507 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.0217 17.805 13.5507 18.0007 13 18H3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
      fill="#D33E3E"
      fill-opacity="0.83"
    />
  </svg>
);
